module.exports = __webpack_public_path__ + "img/share2.73293c51.png";